import React from "react";
import PropTypes from "prop-types";
import Tour from "reactour";
import { AppHeader } from "components/app-header";
import { connect } from "react-redux";
import { StickyContainer, Sticky } from "react-sticky";
import { getTourSteps } from "components/tours/tour-steps";
import { logoutAction, redirectToLoginAction, setOauthTokenAction } from "actions/oauth-actions";
import {
  changeSelectedAccountAction,
  clearFlashMessageAction,
  endSettingsModeAction,
  startSettingsModeAction,
  setFlashMessageAction,
  startNotificationsModeAction,
  endNotificationsModeAction,
  fetchDocumentsAction,
  endGlobalErrorAction,
  endFirstTimeBetaModeAction,
  updateStepIndexAction,
  toggleBetaModalAction,
  endTourAction,
  startTourAction
} from "actions/app-actions";
import { addSearchQueryToFilterAction, updateSearchQueryAction } from "actions/document-filters-actions";
import { focusDocumentAction } from "actions/update-document-actions";
import { storage as localStorage, OAUTH_TOKEN } from "utils/local-storage";
import { bootstrapAction } from "actions/bootstrap-actions";
import { flashType, accountType, documentFiltersType } from "custom-prop-types";
import { UnknownErrorMessage } from "components/common/unknown-error-message";
import { FlashMessage } from "components/common/flash-message";
import { Loading } from "components/common/loading";
import { FirstTimeBetaModal } from "components/first-time-beta-modal";

class App extends React.Component {
  componentDidMount() {
    this.props.init();
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    this.props.onFetchDocuments(this.props.selectedAccount.id, this.props.filters);
    return (
      <StickyContainer>
        <FlashMessage
          message={ this.props.flash.message }
          onHide={ this.props.onHideFlash }
          type={ this.props.flash.type }
        />
        <Sticky stickyStyle={ { zIndex: 9999 } }>
          <AppHeader { ...this.props } />
        </Sticky>
        <div>
          <FirstTimeBetaModal
            isDontRemindBeta={ this.props.isDontRemindBeta }
            isFirstTimeBetaMode={ this.props.isFirstTimeBetaMode }
            onEndFirstTimeBetaMode={ this.props.onEndFirstTimeBetaMode }
            onStartTour={ this.props.onStartTour }
            onToggleBetaModal={ this.props.onToggleBetaModal }
          />
          <UnknownErrorMessage
            accountSlug={ this.props.selectedAccount.slug }
            isGlobalError={ this.props.isGlobalError }
            onEndGlobalError={ this.props.onEndGlobalError }
          />
          { this.props.children }
        </div>
        <Tour
          accentColor={ "#750a88" }
          isOpen={ this.props.isTourOpen }
          onRequestClose={ this.props.onEndTour }
          showButtons={ false }
          showNavigation={ false }
          steps={ getTourSteps(this.props) }
        />
      </StickyContainer>
    );
  }
}

App.propTypes = {
  children: PropTypes.element.isRequired,
  filters: documentFiltersType.isRequired,
  flash: flashType.isRequired,
  init: PropTypes.func.isRequired,
  isDontRemindBeta: PropTypes.bool.isRequired,
  isFirstTimeBetaMode: PropTypes.bool.isRequired,
  isGlobalError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isTourOpen: PropTypes.bool.isRequired,
  onEndFirstTimeBetaMode: PropTypes.func.isRequired,
  onEndGlobalError: PropTypes.func.isRequired,
  onEndTour: PropTypes.func.isRequired,
  onFetchDocuments: PropTypes.func.isRequired,
  onHideFlash: PropTypes.func.isRequired, // () => void
  onStartTour: PropTypes.func.isRequired,
  onToggleBetaModal: PropTypes.func.isRequired,
  selectedAccount: accountType
};

App.defaultProps = {
  selectedAccount: null
};

const matchStateToProps = (state) => ({
  accounts: state.app.accounts,
  accountSlug: state.app.selectedAccount,
  exportFailedCount: state.app.exportFailedCount,
  filters: state.documentFilters,
  flash: state.app.flash,
  isDontRemindBeta: state.app.isDontRemindBeta,
  isFirstTimeBetaMode: state.app.isFirstTimeBetaMode,
  isGlobalError: state.app.isGlobalError,
  isLoading: state.app.isLoading,
  isNotificationsMode: state.app.isNotificationsMode,
  isNotificationsViewed: state.app.isNotificationsViewed,
  isSettingsMode: state.app.isSettingsMode,
  isTourOpen: state.app.isTourOpen,
  isUploadDocumentsVisible: state.pendingDocuments.isUploadDocumentsVisible,
  isUploadLoading: state.pendingDocuments.isUploadLoading,
  oAuthToken: state.oauth.token,
  pendingDocuments: state.pendingDocuments.pendingDocuments,
  queuedCount: state.app.queuedCount,
  searchQueryString: state.documentFilters.searchQueryString,
  documents: state.documents.documents,
  selectedAccount: state.app.selectedAccount,
  tourName: state.app.tourName,
  user: state.app.user
});

const matchDispatchToProps = (dispatch) => ({
  init: () => {
    if (localStorage.isSet(OAUTH_TOKEN)) {
      dispatch(setOauthTokenAction(localStorage.get(OAUTH_TOKEN)));
      dispatch(bootstrapAction());
    } else {
      dispatch(redirectToLoginAction());
    }
  },
  onAddSearchQuery: (query) => dispatch(addSearchQueryToFilterAction(query)),
  onChangeSelectedAccount: (accountId, accountSlug) => dispatch(changeSelectedAccountAction(accountId, accountSlug)),
  onEndFirstTimeBetaMode: (toggle) => dispatch(endFirstTimeBetaModeAction(toggle)),
  onEndGlobalError: () => dispatch(endGlobalErrorAction()),
  onEndNotificationsMode: () => dispatch(endNotificationsModeAction()),
  onEndSettingsMode: () => dispatch(endSettingsModeAction()),
  onEndTour: () => dispatch(endTourAction()),
  onFetchDocuments: (accountId, filters) => dispatch(fetchDocumentsAction(accountId, filters)),
  onFocusDocument: (document, style) => dispatch(focusDocumentAction(document, style)),
  onHideFlash: () => dispatch(clearFlashMessageAction()),
  onLogout: () => dispatch(logoutAction()),
  onStartNotificationsMode: () => dispatch(startNotificationsModeAction()),
  onStartSettingsMode: () => dispatch(startSettingsModeAction()),
  onSetFlashMessage: (message, type) => dispatch(setFlashMessageAction(message, type)),
  onStartTour: (tour) => dispatch(startTourAction(tour)),
  onToggleBetaModal: (toggle) => dispatch(toggleBetaModalAction(toggle)),
  onUpdateSearchQuery: (query) => dispatch(updateSearchQueryAction(query)),
  onUpdateStepIndex: (index) => dispatch(updateStepIndexAction(index))
});

export const AppContainer = connect(matchStateToProps, matchDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/js/containers/app-container.jsx